/**Tipo di licenza del sensore di riconoscimento */
export enum RecognitionSensorLicenseTypeEnum {
    /**Sconosciuto */
    Unknown = 0,

    /**
     * Standard:
     * su CIMA BV5000 consente un numero qualsiasi di caricamenti senza limitazioni
     * su CTS RS12 consente un numero qualsiasi di caricamenti senza limitazioni
     * su G&D CR90 richiede l'utilizzo di una licenza per poter aggiornare il sensore
     */
    Standard = 1,

    /**
     * Universale:
     * su CIMA BV5000 non esiste
     * su CTS RS12 non esiste
     * su G&D CR90 consente un numero qualsiasi di caricamenti entro una data di scadenza specificata
     */
    Universal = 2
}